package music.jammers.client.shared.analytics

actual class FirebaseAnalytics {
    actual fun logEvent(name: String) {
    }

    actual fun logEvent(
        name: String,
        block: FirebaseParametersBuilder.() -> Unit
    ) {
    }

    actual fun setUserId(id: String?) {
    }

    actual fun setUserProperty(name: String, value: String) {
    }

    actual object Event {
        actual val LOGIN: String = "Login"
        actual val SCREEN_VIEW: String = "ScreenView"
    }

    actual object Param {
        actual val SCREEN_NAME: String = "ScreenName"
    }
}

actual class FirebaseParametersBuilder {
    actual fun param(key: String, value: Double) {
    }

    actual fun param(key: String, value: Long) {
    }

    actual fun param(key: String, value: String) {
    }
}